import ApiService from '../service/ApiService';
import LanguageService from '../service/LanguageService';

let moduleApi = {};
let moduleName = "user";

moduleApi.create = (dataForm) => {
    let api = {
        module: moduleName,
        type: "create",
        value: dataForm,
        message: {
            success: "hidden",
            error: "Tên tài khoản đã được sử dụng!"
        },
    };
    return ApiService(api);
};

moduleApi.update = (dataForm) => {
    let api = {
        module: moduleName,
        type: "partialUpdate",
        // message: {
        //   success: "hidden",
        //   error: "hidden"
        // },
        value: dataForm
    };
    return ApiService(api);
};

moduleApi.list = (dataFilter) => {
    let api = {
        module: moduleName,
        type: "list",
        value: dataFilter
    };
    return ApiService(api);
};


moduleApi.delete = (id) => {
    let api = {
        module: moduleName,
        type: "delete",
        value: { id: id }
    };
    return ApiService(api);
};


moduleApi.findById = (id) => {
    let api = {
        module: moduleName,
        type: "findById",
        value: { id: id }
    };
    return ApiService(api);
};

moduleApi.disable = (id, message_success) => {
    let api = {
        module: moduleName,
        type: "partialUpdate",
        message: {
            success: message_success ? message_success : LanguageService.lang.user_disableSuccess,
            error: LanguageService.lang.user_disableError
        },
        value: {
            id: id,
            disabled: true
        }
    };
    return ApiService(api);
};

moduleApi.undisable = (id, message_success) => {
    let api = {
        module: moduleName,
        type: "partialUpdate",
        message: {
            success: message_success ? message_success : LanguageService.lang.user_undisableSuccess,
            error: LanguageService.lang.user_undisableError
        },
        value: {
            id: id,
            disabled: false
        }
    };
    return ApiService(api);
};

moduleApi.register = (dataForm) => {
    let api = {
        module: moduleName,
        type: "register",
        value: dataForm,
        message: {
            success: "Đăng ký người dùng thành công",
            error: "hidden"
        },
    };
    return ApiService(api);
};

moduleApi.registerSafePlaceUser = (dataForm) => {
    let api = {
        module: moduleName,
        type: "registerSafePlaceUser",
        value: dataForm,
        message: {
            success: "Đăng ký thành công",
            error: "hidden"
        },
    };
    return ApiService(api);
};
moduleApi.generateHashCode = (dataForm) => {
    let api = {
        module: moduleName,
        type: "generateHashCode",
        value: dataForm,
        message: {
            success: "hidden",
            error: "hidden"
        },
    };
    return ApiService(api);
};
moduleApi.getUserIdOrFetchAcsUser = (dataForm) => {
    let api = {
        module: moduleName,
        type: "getUserIdOrFetchAcsUser",
        value: dataForm,
        message: {
            success: "hidden",
            error: "Mã thẻ/Mã MS không tồn tại"
        },
    };
    return ApiService(api);
};


export default moduleApi;